import { Modal } from '@ai-tutor/ui';
import { FORMAT_CATEGORIES } from './types';

interface SupportedFormatsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Secondary modal listing every supported file extension, grouped by
 * category. Opened from the "Supported file types" link in UploadFileTab.
 *
 * Renders on top of the parent AttachSourceModal - both use the same
 * `Modal` primitive at z-50 so the later-rendered child wins paint order.
 */
export function SupportedFormatsModal({
  isOpen,
  onClose,
}: SupportedFormatsModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title='Supported file types'
      size='md'
      overlayClassName='bg-black/30 backdrop-blur-sm'
      contentClassName='border border-border bg-card shadow-xl'
    >
      <div className='flex flex-col gap-4 px-6 pb-6 pt-4'>
        <p className='text-xs text-muted-foreground'>
          Text is automatically extracted from documents, spreadsheets, slides,
          and images (via OCR). Audio and video aren't supported yet.
        </p>

        <div className='space-y-4'>
          {FORMAT_CATEGORIES.map(cat => (
            <div key={cat.label}>
              <div className='mb-1 flex items-baseline justify-between gap-2'>
                <h3 className='text-sm font-semibold text-foreground'>
                  {cat.label}
                </h3>
                <span className='text-[11px] text-muted-foreground'>
                  {cat.description}
                </span>
              </div>
              <div className='flex flex-wrap gap-1.5'>
                {cat.exts.map(ext => (
                  <span
                    key={ext}
                    className='rounded-sm border border-border bg-muted px-1.5 py-0.5 font-mono text-[11px] text-muted-foreground'
                  >
                    .{ext}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
